<template>
  <v-app>
    <NavBar />
    <router-view />
  </v-app>
</template>

<script>
import NavBar from './components/NavBar.vue'
import { watch, onMounted } from 'vue'
import { useRtl } from 'vuetify'
import { useI18n } from 'vue-i18n'

export default {
  components: { NavBar },
  setup() {
    const { isRtl } = useRtl()     // manages RTL boolean
    const { locale } = useI18n()   // your vue-i18n locale

    // Watch for changes to the i18n locale
    watch(locale, (newVal) => {
      // If the user picks 'ar', enable RTL
      isRtl.value = (newVal === 'ar')
      // Optionally, set the direction attribute on the HTML element
      document.documentElement.dir = (newVal === 'ar') ? 'rtl' : 'ltr'
    })

    // Set initial RTL value on mount
    onMounted(() => {
      isRtl.value = (locale.value === 'ar')
      document.documentElement.dir = (locale.value === 'ar') ? 'rtl' : 'ltr'
    })

    return {}
  }
}
</script>

<style>
/* Global styles if needed */
</style>
